
import PaginatedReviewResourceView from '@/mixins/PaginatedReviewResourceView';
import { mapState, mapActions, mapGetters } from 'vuex';
import BoardShowReviewInfoOption from '@/enums/BoardShowReviewInfoOption';

export default {
  i18nComponentKey: 'WidgetProductReviewsBoard.WidgetProductReviewsBoardMobile',
  name: 'WidgetProductReviewsBoardMobile',
  mixins: [PaginatedReviewResourceView],
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('review', [
      'totalReviewsCount',
      'totalProductMediaReviewsCount'
    ]),
    ...mapGetters('widget', [
      'headerSectionShowable',
      'showFilterSection',
      'appHeaderV2AndTitleShowable'
    ]),
    defaultResourceParams() {
      return {
        fields: [
          'has_media',
          'total_reviews_count',
          'total_product_media_reviews_count'
        ].join(',')
      };
    },
    reviewsContainerStyle() {
      return {
        '--min-height': this.showFilterSection ? '204px' : 'auto'
      };
    },
    shouldDisplayLikesCount() {
      return (
        this.reviewSettings.use_likes_count &&
        (this.widget.board_show_review_info_option &
          BoardShowReviewInfoOption.SHOW_LIKES_COUNT) >
          0
      );
    }
  },
  created() {
    if (this.widget.show_product_score)
      this.fetchProductScoreSummary({ fields: 'scores_map' });
    if (this.widget.show_header_section) this.fetchReviewWritableCheck();
  },
  methods: {
    ...mapActions('productScoreSummary', ['fetchProductScoreSummary']),
    ...mapActions('review', ['fetchReviewWritableCheck']),
    ...mapActions('widget', ['openReviewPopup']),
    submit(params) {
      this.searchResource(params);
    },
    shouldDisplayThumbnail(review) {
      return (
        (this.widget.board_show_review_info_option &
          BoardShowReviewInfoOption.SHOW_THUMBNAIL) >
          0 &&
        (review.images.length > 0 || review.videos.length > 0)
      );
    }
  }
};
